module.exports = __webpack_public_path__ + "img/home_auth5.342d7ae8.png";